import { throttle } from './function';
import { getNavigationTopOffsetProperty, setNavigationTopOffsetProperty } from '../components/navigation_top_offset';
function buildWindowScrollHandler(onScrollDown, onScrollUp) {
    const scrollDelayPx = 150;
    let lastScrollPosition = window.pageYOffset;
    let scrollDelta = 0;
    let scrollDirection = 0;
    let handledScrollDirection = 0;
    const handleScroll = () => {
        let currentScrollPosition = window.pageYOffset;
        // scroll can bounce when scrolling to the top or bottom of the page
        if (currentScrollPosition < 0) {
            currentScrollPosition = 0;
        }
        else if (window.innerHeight + currentScrollPosition > document.body.offsetHeight) {
            currentScrollPosition = document.body.offsetHeight - window.innerHeight;
        }
        if (currentScrollPosition !== lastScrollPosition) {
            const delta = currentScrollPosition - lastScrollPosition;
            const newScrollDirection = Math.sign(delta);
            if (newScrollDirection !== scrollDirection) {
                scrollDelta = delta;
                scrollDirection = newScrollDirection;
            }
            else {
                scrollDelta += delta;
            }
            if (newScrollDirection !== handledScrollDirection) {
                if (scrollDelta >= scrollDelayPx) {
                    handledScrollDirection = newScrollDirection;
                    onScrollDown();
                }
                else if (scrollDelta <= -scrollDelayPx) {
                    handledScrollDirection = newScrollDirection;
                    onScrollUp();
                }
            }
            lastScrollPosition = currentScrollPosition;
        }
    };
    return throttle(handleScroll, 10);
}
export function hideOrShowNavSectionOnScroll(navigationType, navSection, sectionHeight, hiddenClass) {
    const hideNavSection = () => {
        const navHeight = getNavigationTopOffsetProperty(navigationType);
        if (!navSection.classList.contains(hiddenClass) && navHeight !== 0) {
            setNavigationTopOffsetProperty(navigationType, navHeight - sectionHeight);
            navSection.classList.add(hiddenClass);
        }
    };
    const showNavSection = () => {
        const navHeight = getNavigationTopOffsetProperty(navigationType);
        if (navSection.classList.contains(hiddenClass) && navHeight !== 0) {
            setNavigationTopOffsetProperty(navigationType, navHeight + sectionHeight);
            navSection.classList.remove(hiddenClass);
        }
    };
    navSection.addEventListener('focusin', showNavSection);
    // we add scroll listener with a small delay
    // to avoid a race condition with the browser scrolling to a hash element
    setTimeout(() => {
        const onScroll = buildWindowScrollHandler(hideNavSection, showNavSection);
        document.addEventListener('scroll', onScroll);
        window.up.destructor(navSection, () => document.removeEventListener('scroll', onScroll));
    }, 100);
}
